import React from 'react';
import { Row, Col, Table, Button } from 'antd';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Card, Container, Title, GoBack } from 'src/components';
import { table } from 'src/utils';
import { IReduxState } from 'src/store';
import { fetchProducts, removeProduct } from 'src/store/products/actions';

import { IProps } from './products.type';
import { columns } from './products.utils';
import useProducts from './products.use';

import Pagination from './components/pagination/pagination.component';

const ProductsScreen: React.FC<IProps> = (props) => {
  useProducts(props);

  const { products } = props;
  const { handleRemove, handleProducts } = useProducts(props);

  const navigate = useNavigate();

  return (
    <Container type="fluid">
      <Row gutter={16} className="mt-2" align="middle" justify="space-between">
        <Col>
          <GoBack color="#444" />
          <Title
            foreword="Configurações"
            title="Produtos"
            subtitle="Visualize abaixo a lista de produtos cadastrados no sistema, clique no botão ao lado para adicionar mais."
          />
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => navigate('/painel/produtos/novo')}
          >
            Adicionar Novo
          </Button>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Card>
            <Table
              {...table}
              rowKey={(record: any) => record.id}
              columns={columns(handleRemove)}
              dataSource={products?.data}
              bordered
              pagination={false}
            />
          </Card>
        </Col>
        <Col span={24}>
          <Pagination
            pagesMeta={products?.meta}
            handleSearch={handleProducts}
          />
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  products: state.products.all,
});

export default connect(mapStateToProps, { fetchProducts, removeProduct })(
  ProductsScreen
);
